const DEFAULT_INVITE_EXPIRATION_HOURS = 24 * 5

export const isInviteExpired = (time: Date, expirationHours?: number) => {
    expirationHours = expirationHours || DEFAULT_INVITE_EXPIRATION_HOURS
    const inviteTime = new Date(time)
    const now = new Date()
    const prev = new Date()

    prev.setHours(now.getHours() - expirationHours)

    return inviteTime < prev
}
